module.exports = __webpack_public_path__ + "static/images/hero.cbdea04218784d243b0cb8adc08942d1.jpg";